import { UseFormSetError } from 'react-hook-form';
import { z } from 'zod';
export function applyServerIssues(issues: z.core.$ZodIssue[], setError: UseFormSetError<Record<string, unknown>>) {
  issues.forEach(issue => {
    const fieldName = issue.path[0] as string;
    setError(fieldName, {
      type: 'server',
      message: issue.message
    });
  });
}